export enum Taxgroups {
    AIRS = 'AIRS',
    MDA = 'MDA',
}